import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const sisense = defineConnector({
  identifier: "sisense",
  name: "Sisense",
  tagLine: "Embedded analytics platform",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create a Sisense API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Sisense, open **User Profile → API Token** and copy or regenerate your API token.",
        },
      ],
    },
    {
      title: "Enter your Sisense details",
      items: [
        {
          kind: "url",
          label: "Sisense URL",
          required: true,
          placeholder: "https://sisense.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => ({
      url: `${instanceUrl}/api/dashboards`,
      expectedStatus: [200, 403],
    }),
  },
});
